<template>
  <div class="pagination-wrapper">
    <el-pagination
      :layout="layout"
      :total="total"
      :page-size="pageSize"
      :hide-on-single-page="hideOnSinglePage"
      @current-change="handleCurrentChange"
       />
  </div>
</template>

<script>
/* eslint-disable */
import { Pagination } from 'element-ui';

export default {
  props: {
    pageSize: {
      type: Number,
      default: 5,
    },
    total: {
      type: Number,
      default: 50,
    },
    layout: {
      type: String,
      default: 'prev, pager, next',
    },
    hideOnSinglePage: {
      type: Boolean,
      default: true,
    }
  },
  components: {
    ElPagination: Pagination,
  },
  data() {
    return {
    };
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    handleCurrentChange(val) {
      this.$emit('changePage', val)
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
.pagination-wrapper {
  display: flex;
  justify-content: center;
  /deep/ .el-pagination {
    .el-pager {
      li {
        padding: 0;
        margin: 0 8px;
        min-width: 30px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 1.5vh;
      }
      .number {
        color: #5A5FEF;
        border-radius: 50%;
        background-color: #ebecfd;
      }
      .active {
        color: #fff;
        background-color: #5A5FEF;
      }
/*       button:hover {
        color: $primary;
      }
      .number:hover {
        color: $primary;
      } */
    }
    button {
      margin: 0 8px;
      padding: 0;
      width: 30px;
      height: 30px;
      color: #fff;
      line-height: 30px;
      min-width: 30px;
      border-radius: 50%;
      background-color: #5A5FEF;
    }
  }
}
</style>
